// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-3308d19c]::-webkit-scrollbar{display:none!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
